export default "__VITE_ASSET__d5e5300d__"